// action types
import { createRequestTypes } from "../../utils";

export const FETCH_DASHBOARD_NEWS = createRequestTypes("FETCH_DASHBOARD_NEWS");

export const fetchDashboardNewsRequest = () =>
    ({ type: FETCH_DASHBOARD_NEWS.REQUEST });

export const fetchDashboardNewsSuccess = (news, count) =>
    ({ type: FETCH_DASHBOARD_NEWS.SUCCESS, payload: { news, count } });

export const fetchDashboardNewsFailure = (error) =>
    ({ type: FETCH_DASHBOARD_NEWS.FAILURE, payload: { error } });